import Tr from 'translations/Translations';

export const isNonpublicProcedure = (procedureType) => {
	return procedureType === ProcedureType.NATIONAL_NONPUBLIC_TYPE || procedureType === ProcedureType.NATIONAL_LOWCOST_TYPE;
}
export const isNationalProcedure = (procedureType) => {
	return procedureType === ProcedureType.NATIONAL_PUBLIC || procedureType === ProcedureType.NATIONAL_SOCIAL_SERVICES;
}
export const isEuropeProcedure = (procedureType) => {
	 return  procedureType === ProcedureType.EUROPE_PUBLIC || procedureType === ProcedureType.EUROPE_SOCIAL_SERVICES;
}

export const ProcedureType = {
	COMPETITION: "competition",
	DEMAND: "demand",
	DYNAMICPURCHASINGSYSTEM: "dynamicPurchasingSystem",
	FRAMEWORKDEMAND: "frameworkdemand",
	LOWCOST: "lowcost",
	PUBLIC: "public",
	RESEARCH: "research",
	RESEARCHTECHNICAL: "researchtechnical",
	SOCIALSERVICES: "socialservices",
	STANDARDPURCHASEREQUEST: "standardpurchaserequest",
	NONPUBLICEXECUTIVE: "nonpublicExecutive",
	EUROPE_PUBLIC: "europePublic",
	NATIONAL_PUBLIC: "nationalPublic",
	NATIONAL_SOCIAL_SERVICES: "nationalSocialServices",
	EUROPE_SOCIAL_SERVICES: "europeSocialServices",
	NATIONAL_NONPUBLIC_TYPE: "nationalNonpublic",
	NATIONAL_LOWCOST_TYPE: "nationalLowcost",
	NATIONAL_LOWCOST: "nationalLowcost",
	NATIONAL_RESEARCH_TYPE: "nationalResearch",
	CONCESSION: "concession"
}

export const ProcedureTypeTr = {
	[ProcedureType.COMPETITION]: Tr("competition"),
	[ProcedureType.DEMAND]: Tr("demand"),
	[ProcedureType.DYNAMICPURCHASINGSYSTEM]: Tr("dynamicpurchasingsystem"),
	[ProcedureType.FRAMEWORKDEMAND]: Tr("frameworkdemand"),
	[ProcedureType.LOWCOST]: Tr("lowcost"),
	[ProcedureType.PUBLIC]: Tr("public"),
	[ProcedureType.RESEARCH]: Tr("research"),
	[ProcedureType.RESEARCHTECHNICAL]: Tr("researchtechnical"),
	[ProcedureType.SOCIALSERVICES]: Tr("socialservices"),
	[ProcedureType.STANDARDPURCHASEREQUEST]: Tr("standardpurchaserequest"),
	[ProcedureType.NONPUBLICEXECUTIVE]: Tr(ProcedureType.NONPUBLICEXECUTIVE),
	[ProcedureType.EUROPE_PUBLIC]: Tr(ProcedureType.EUROPE_PUBLIC),
	[ProcedureType.EUROPE_SOCIAL_SERVICES]: Tr(ProcedureType.EUROPE_SOCIAL_SERVICES),
	[ProcedureType.NATIONAL_PUBLIC]: Tr(ProcedureType.NATIONAL_PUBLIC),
	[ProcedureType.NATIONAL_SOCIAL_SERVICES]: Tr(ProcedureType.NATIONAL_SOCIAL_SERVICES),
	[ProcedureType.NATIONAL_NONPUBLIC_TYPE]: Tr(ProcedureType.NATIONAL_NONPUBLIC_TYPE),
	[ProcedureType.NATIONAL_LOWCOST_TYPE]: Tr(ProcedureType.NATIONAL_LOWCOST_TYPE),
	[ProcedureType.NATIONAL_LOWCOST]: Tr(ProcedureType.NATIONAL_LOWCOST_TYPE),
	[ProcedureType.NATIONAL_RESEARCH_TYPE]: Tr(ProcedureType.NATIONAL_RESEARCH_TYPE),
	[ProcedureType.CONCESSION]: Tr(ProcedureType.CONCESSION)
}

export const ProcedureType_PZP_2021 = [
	ProcedureType.EUROPE_PUBLIC,
	ProcedureType.NATIONAL_PUBLIC,
	ProcedureType.EUROPE_SOCIAL_SERVICES,
	ProcedureType.NATIONAL_SOCIAL_SERVICES,
	ProcedureType.NATIONAL_NONPUBLIC_TYPE,
	ProcedureType.NATIONAL_LOWCOST_TYPE,
	ProcedureType.NATIONAL_RESEARCH_TYPE,
	ProcedureType.CONCESSION
]

export default Object.values(ProcedureTypeTr)
